/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDataTime = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 3a1 1 0 0 1 1-1h6.001A3.99 3.99 0 0 1 12 3.354 3.99 3.99 0 0 1 14.999 2H21a1 1 0 0 1 1 1v10.022a6.463 6.463 0 0 0-2-.848V4h-5.001A2 2 0 0 0 13 5.999v9.035a6.47 6.47 0 0 0-1 3.466 6.47 6.47 0 0 0 .791 3.11A1 1 0 0 1 11 20.999 1.998 1.998 0 0 0 9 19H3a1 1 0 0 1-1-1zm9 14.534V5.999A2 2 0 0 0 9.001 4H4v12.999h5c.729 0 1.412.195 2 .535z" />
        <path d="M18.5 23a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm-.6-4.252V15.8h1.2v2.451l1.174 1.175-.848.848z" />
      </g>
    </g>
  </Icon>
);
export { SvgDataTime as DataTime };
